import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'
export default {
    path: '/study_progress',
    name: 'studyProgress',
    meta: {
        title: '学习进度',
        isAdmin: true
    },
    component: Layout,
    redirect: '/study_progress/progress_list',
    children: [
        {
            path: 'progress_list',
            name: 'progressList',
            meta: {
                title: '学习进度列表',
                isAdmin: true
            },
            component: resolve => require(['@/views/studyProgress/progressList/Index.vue'], resolve),
        },
        {
            path: 'progress_list',
            meta: {
                title: '学习进度列表',
                isAdmin: true
            },
            component:Empty,
            children: [
                {
                    path: 'progress_details',
                    name: 'progressDetails',
                    alias: '/progressDetails_3',
                    meta: {
                        title: '进度详情',
                        isAdmin: true
                    },
                    component: resolve => require(['@/views/studyProgress/progressDetails/Index.vue'], resolve),
                },
            ]
        },
    ]
}
